import React, { useEffect, useState } from 'react';

import { createPostRequest } from "Utils/Common";

import PayerVendor from './views/Recouveo/Accueil/Modal/PayerVendor';

import { useParams, useNavigate, useLocation } from "react-router-dom";

const DirectPayment = () => {
    const [ form, setForm ] = useState();

    const { token } = useParams();
    const navigate = useNavigate();
    // const location = useLocation();
    
    // const basePath = "/" + location.pathname.split("/")[1];
    // const url = window.location.origin + window.location.hash;

    const baseUrl = window.location.origin;
    const hash = window.location.hash;

    const shortHash = hash.split("/").slice(0, 2).join("/");

    const url = baseUrl + shortHash;

    useEffect(() => {
        createPostRequest('verify_accessToken', {token, path: 'p', url})
            .then(resp => resp.data)
            .then(resp => {
                if( !resp.success ){
                    if( resp.redirect ){
                        return navigate(resp.redirect, { replace: true });
                    }
                    const message = resp?.error ? [resp.error] : ["HomeModalPaidErrorHasOccurred","HomeModalPaidPleaseTryAgainLater"];
                    navigate("/p", { replace: true, state: { message } });
                    return ;
                }

                setForm(resp.form);
            })
            .catch(err => {
                console.error(err);
                navigate("/p", { replace: true, state: { message: ["HomeModalPaidErrorHasOccurred","HomeModalPaidPleaseTryAgainLater"] } });
            })
    }, [token]);

    return(
        <>
            { form && <PayerVendor formConfig={form} /> }
        </>
    );
}

export default DirectPayment;